import { methodBuilder } from "../builders/method.builder";
import { RestClient } from "../client/rest.client";

export let GET = methodBuilder("GET");
export let POST = methodBuilder("POST");
export let PUT = methodBuilder("PUT");
export let DELETE = methodBuilder("DELETE");
export let HEAD = methodBuilder("HEAD");
